import { getComponentKey } from 'utils/getComponentKey'

export const initialState = {
  entity: null,
  fetching: false,
  saving: false,
  deleting: false,
  restoring: false,
  gridKey: getComponentKey(),
  error: null
}

export const lookupInitialState = {
  entity: null,
  fetching: false
}